import { useAuth, useUserProfile } from '../../store/hooks'

import { ProfileForm } from './ProfileForm'
import { EmailVerification } from './EmailVerification'

export function ManageProfile() {
  const { profile, updateProfile } = useUserProfile()
  const { authUser, onSendVerificationEmail } = useAuth()

  if (!profile || !authUser) {
    return (
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Loading...</h1>
      </div>
    )
  }

  return (
    <div className="space-y-8">
      <ProfileForm profile={profile} updateProfile={updateProfile} />
      <EmailVerification
        user={authUser}
        sendVerificationEmail={onSendVerificationEmail}
      />
    </div>
  )
}
